import React from "react"
import { createElement } from "./create-element"
import { HeaderEditor } from "../editor/header-editor"
import { ContentEditor } from "../editor/content-editor"

import { ButtonElement } from "./button-element"
import { ImageElement } from "./image-element"
import { Input } from "./input-element"
import { PoweredByElement } from "./powered-by-element"
import { PoweredByConvertKitElement } from "./powered-by-convertkit-element"
import { BuiltWithElement } from "./built-with-element"
import { CustomFields } from "./custom-fields"
import { AddFieldButton } from "./add-field-button"
import { VideoElement } from "./video-element"
import { EventElement } from "./event-element"
import { LinksContainer as LinksElement } from "./links-element"
import { IconContainer as IconsElement } from "./icons-element"
import { Feed as FeedElement } from "./feed-element"
import { ImageGallery as GalleryElement } from "./gallery-element"
import { LandingPage, Form } from "../landing-page"
import { Region } from "./region"
import { Price } from "./price"
import { MultiplePrices } from "./multiple-prices"
import { PayWhatYouWantInput } from "./pay-what-you-want-input"
import { QuantityInput } from "./quantity-input"
import { TipButtons } from "./tip-buttons"
import { Types } from "./types"

export const Button = createElement(ButtonElement, { type: Types.Button })
export const Content = createElement(ContentEditor, { type: Types.Text })
export const Header = createElement(HeaderEditor, {
  tag: "h1",
  type: Types.Text
})

export const Image = createElement(ImageElement, { type: Types.Image })
export const Video = createElement(VideoElement, { type: Types.Video })
export const Event = createElement(EventElement, { type: Types.Event })
export const Links = createElement(LinksElement, { type: Types.Links })
export const Icons = createElement(IconsElement, { type: Types.Icons })
export const Feed = createElement(FeedElement, { type: Types.Feed })
export const Gallery = createElement(GalleryElement, { type: Types.Gallery })
export { Input } // We import the already created Input element from input-element.js so we avoid Circular dependency

export const PoweredBy = createElement(PoweredByElement, {
  name: "powered-by",
  type: Types.Null
})
export const PoweredByConvertKit = createElement(PoweredByConvertKitElement, {
  name: "powered-by",
  type: Types.Null
})
export const BuiltWith = createElement(BuiltWithElement, {
  name: "powered-by",
  type: Types.Null
})
export const Errors = () => (
  <ul
    className="formkit-alert formkit-alert-error"
    data-element="errors"
    data-group="alert"
  />
)
export const Success = () => (
  <div
    className="formkit-alert formkit-alert-success"
    data-element="success"
    data-group="alert"
  />
)
export { CustomFields, AddFieldButton }

function register(name, component) {
  if (typeof window === "undefined") return
  if (!window.__components) {
    window.__components = {}
  }
  window.__components[name] = component
}

register("Heading", Header)
register("Content", Content)
register("AddFieldButton", AddFieldButton)
register("Button", Button)
register("CustomFields", CustomFields)
register("Errors", Errors)
register("Event", Event)
register("PoweredBy", PoweredBy)
register("PoweredByConvertKit", PoweredByConvertKit)
register("BuiltWith", BuiltWith)
register("Video", Video)
register("Image", Image)
register("LandingPage", LandingPage)
register("Form", Form)
register("Region", Region)
register("Price", Price)
register("Links", Links)
register("Icons", Icons)
register("Feed", Feed)
register("Gallery", Gallery)
register("MultiplePrices", MultiplePrices)
register("PayWhatYouWantInput", PayWhatYouWantInput)
register("QuantityInput", QuantityInput)
register("TipButtons", TipButtons)
